export const handleChangeDataPagesVisitRequest = (name, value) => ({
    type: 'CHANGE_DATA_PAGES_VISIT_REQUEST', name, value
});